import React from "react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { situations } from "../../data/content";
export function SituationsSection() {
  return <section className="bg-canvas px-4 py-16 sm:py-24" data-id="element-306" data-mp="3lf8bc0ysb2ck">
      <div className="mx-auto max-w-4xl" data-id="element-307" data-mp="3lcm27ww8wes8">
        <SectionHeading title="Do you recognize yourself in any of these situations?" intro="If you answer YES to any of these questions, this collection was designed around learning needs like yours." data-id="element-308" data-mp="3qd9vyqbuz9q5" />

        <ol className="mt-10 divide-y divide-line overflow-hidden rounded-3xl bg-white ring-1 ring-line" data-id="element-309" data-mp="3gh6t1i96n725">
          {situations.map((s, i) => <li key={s.title} className="flex gap-4 p-5 sm:gap-6 sm:p-7" data-id="element-310" data-mp="37ep4uy9yw4ci" data-mpi={i}>
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-navy text-lg font-extrabold text-gold" data-id="element-311" data-mp="37h1mfabtccp1">
                {i + 1}
              </span>
              <div data-id="element-312" data-mp="15msv9u7d14kd">
                <h3 className="text-lg font-extrabold leading-snug text-navy sm:text-xl" data-id="element-313" data-mp="15l8145oyjnn1">{s.title}</h3>
                <p className="mt-2 text-base leading-relaxed text-muted" data-id="element-314" data-mp="295bzbsxjq9e7">{s.body}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-10 rounded-3xl bg-navy p-6 text-center sm:p-10" data-id="element-315" data-mp="2hyxbr5m8nekg">
          <p className="text-2xl font-extrabold leading-snug text-white sm:text-3xl" data-id="element-316" data-mp="2dxvbqmkhyyhf">
            The problem isn’t always a lack of information.
          </p>
          <p className="mt-3 text-lg leading-relaxed text-brand-sky" data-id="element-317" data-mp="1qawyryvl68o9">
            Sometimes, it’s the lack of a <span className="font-bold text-gold" data-id="element-318" data-mp="1lbsrjds82l0k">clear system</span> for organizing what you’re learning.
            That’s the purpose of the Hemodynamic Monitoring Blueprint™.
          </p>
        </div>

        <SectionCta label="Yes! I want the complete Blueprint™" data-id="element-319" data-mp="1ucqvxx6koujo" />
      </div>
    </section>;
}